import React, { createContext, useContext } from "react";

import { BulkUpdateModal } from "./bulk_update_modal";
import { useBulkUpdate, UseBulkUpdateType } from "./use_bulk_update";

type BulkUpdateContextType = {
  modal: UseBulkUpdateType;
};

const BulkUpdateContext = createContext({} as BulkUpdateContextType);

export const BulkUpdateContextProvider = ({ children }: React.PropsWithChildren) => {
  const modal = useBulkUpdate();

  const { state } = modal;

  return (
    <BulkUpdateContext.Provider value={{ modal }}>
      {children}
      {state.isOpen && state.selection && <BulkUpdateModal />}
    </BulkUpdateContext.Provider>
  );
};

export const useBulkUpdateContext = () => useContext(BulkUpdateContext);
